export function parseYearMonth(value) {
  if (!/^\d{4}-\d{2}$/.test(value || "")) return null;
  const [year, month] = value.split("-").map(Number);
  if (!Number.isInteger(year) || !Number.isInteger(month) || month < 1 || month > 12) return null;
  return { year, month };
}

export function formatMonthLabel(value) {
  const parsed = parseYearMonth(value);
  if (!parsed) return value || "";
  return new Date(Date.UTC(parsed.year, parsed.month - 1, 1)).toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function buildMonthSeoMeta(yearMonth, options = {}) {
  const { count = 0, notableShows = [] } = options;
  const label = formatMonthLabel(yearMonth);
  const title = `New TV Shows Premiering ${label} | PremiereLens`;

  // Build rich description with count and notable shows
  let description;
  if (count > 0 && notableShows.length > 0) {
    const showNames = notableShows.slice(0, 3).join(", ");
    description = `${count} new TV premieres in ${label} including ${showNames}. Complete schedule of curated scripted series and returning seasons.`;
  } else if (count > 0) {
    description = `${count} new TV premieres in ${label}. Complete schedule of curated scripted series and returning seasons.`;
  } else {
    description = `New scripted TV premieres and returning seasons for ${label}, curated by PremiereLens.`;
  }

  // Truncate if too long
  if (description.length > 155) {
    description = `${description.slice(0, 152).trimEnd()}...`;
  }

  const canonicalUrl = `https://premierelens.com/month/${yearMonth}`;
  return {
    title,
    description,
    canonicalUrl,
    ogUrl: canonicalUrl,
    image: "https://premierelens.com/og-image.jpg",
    robots: "index,follow",
    label,
  };
}
